"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreTagsByIdDeleteAsyncSlice = void 0;
const name_1 = require("./name.js");
const remove_1 = require("../remove.js");
const _api_1 = require("../../../api/index.js");
const actions_1 = require("../_idMap/actions.js");
const actions_2 = require("../../sonar-objects/_idMap/actions.js");
const sonar_analytics_1 = require("@sonar-software/sonar-analytics");
const xuder_1 = require("@sonar-software/xuder");
exports.coreTagsByIdDeleteAsyncSlice = (0, xuder_1.createDeleteAsyncSlice)({
    additionalRequestSteps: [
        {
            actionHandler: (0, sonar_analytics_1.createLogSaga)(sonar_analytics_1.AMPLITUDE_EVENT.TAG_DELETED, (action) => ({
                sonarObjectTagId: action.data.id
            })),
            type: xuder_1.SagaYieldType.Every
        }
    ],
    httpSagaOptions: {
        successCombinationActionCreators: [
            (request) => remove_1.coreTagsRemoveSyncSlice.syncActionCreator(request),
            (request) => (0, actions_1.removeTagReference)(request),
            (request) => (0, actions_2.updateAllSonarObjectReferences)({
                tags: {
                    toRemove: request.id
                }
            })
        ]
    },
    name: name_1.CoreTagsByIdName,
    receive: false,
    request: true,
    requestHandler: _api_1.deleteTag
});
//# sourceMappingURL=delete.js.map